import { useState } from "react";

import { Button, Loader } from "@braintrust/braintrust-ui-components";
import { fetchCurrentUser } from "@js/apps/auth/actions";
import { useFreelancerId } from "@js/apps/common/hooks/use-freelancer-id";
import {
  fetchFreelancerProfile,
  updateFreelancerProfile,
} from "@js/apps/freelancer/actions";
import { Snackbar } from "@js/components/snackbar";
import { useAppDispatch } from "@js/hooks/redux";

export const TaxDocumentOverrideButton = ({
  formType,
}: {
  formType: EnumType<typeof ENUMS.TaxForm>;
}) => {
  const freelancerId = useFreelancerId() as number;
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const switchToName = formType === ENUMS.TaxForm.W9_FORM ? "W8" : "W9";

  const handleSwitchClick = async () => {
    const switchValue =
      formType === ENUMS.TaxForm.W9_FORM
        ? ENUMS.TaxForm.W8_FORM
        : ENUMS.TaxForm.W9_FORM;
    setIsLoading(true);
    try {
      await dispatch(
        updateFreelancerProfile({
          freelancerId: freelancerId,
          updatedValues: { overridden_tax_form: switchValue },
        }),
      );
      await Promise.all([
        dispatch(fetchCurrentUser()),
        dispatch(fetchFreelancerProfile(freelancerId)),
      ]);
    } catch {
      Snackbar.error("Failed to switch tax form");
    }
    setIsLoading(false);
  };

  return (
    <Button
      variant="tertiary"
      size="small"
      onClick={handleSwitchClick}
      disabled={isLoading}
      endIcon={isLoading ? <Loader size={20} /> : undefined}
      sx={{ fontWeight: "400 !important", flexShrink: 0 }}
    >
      {isLoading ? "Switching..." : `Switch to ${switchToName}`}
    </Button>
  );
};
